import type { CallReading } from "@/types/devicePanel";

type ShownCall = Exclude<CallReading["kind"], "hidden">;

// Non-hue state cues (AGENTS.md): Flagged = signal tint, consider = dashed
// neutral in lowercase, below (a compared reading under its default) = plain dim
// text, incomplete = dashed and dimmed. The word carries the meaning.
const CUE: Record<ShownCall, { label: string; className: string }> = {
  flagged: { label: "Flagged", className: "bg-signal-tint text-signal-text-tint uppercase" },
  consider: {
    label: "consider",
    className: "border border-dashed border-border-strong text-fg-muted",
  },
  below: { label: "below", className: "text-fg-dim" },
  incomplete: {
    label: "incomplete",
    className: "border border-dashed border-border-strong text-fg-dim opacity-60",
  },
};

/** A shown call's word: Flagged or consider (below only in a comparison), or
 * incomplete when it cannot be placed. */
export function CallChip({ kind, small = false }: { kind: ShownCall; small?: boolean }) {
  const { label, className } = CUE[kind];
  return (
    <span
      data-call-word={kind}
      className={`inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-xs font-mono tracking-[0.04em] ${
        small ? "px-1 text-[9px] leading-[14px]" : "px-[5px] text-[10px] leading-4"
      } ${className}`}
    >
      {label}
    </span>
  );
}
